import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Icon,
  Box,
  Button,
  Chip,
  Divider,
  FormControlLabel,
  Grid,
  MenuItem,
  Paper,
  Stack,
  Switch,
  Tab,
  Tabs,
  TextField,
  Typography
} from "@mui/material";
import { useDialog } from "muibox";
import { useEffect, useState } from "react";
import {
  useAbortarProcessamentoEventos,
  useAtualizarProcessamentoLotes,
  useAutomacaoStatus,
  useConfigurarAutomacao,
  useConsultarIdentificadoresTrabalhador,
  useConsultarLote,
  useConsultarRet,
  useEnviarEventos,
  useEnviarExclusaoLista,
  useForcarEstadoEventos,
  useSolicitarDownloadPorId,
  useSolicitarDownloadPorNrRecibo
} from "../../api/ESocialJTServiceApi";
import DataPanel from "../../components/data/DataPanel";
import Page from "../../components/layout/page/Page";
import PageHeader from "../../components/page-header/PageHeader";
import useFeedback from "../../components/feedback/useFeedback";

import ResultadoOperacao from "../../components/operacional/ResultadoOperacao";
import { TotalizadoresConsulta } from "../totalizadores/TotalizadoresPage";
import RecuperacaoAssistida from "./RecuperacaoAssistida";
import { useSearchParams } from "react-router-dom";

const RET_TYPES = [
  { value: "empregado", label: "Empregado" },
  { value: "trabalhadorsemvinculo", label: "Trabalhador sem vínculo" },
  { value: "beneficiario", label: "Beneficiário" }
];

const ESTADOS_EVENTO = [
  { value: "1", label: "1 - Em fila" },
  { value: "2", label: "2 - Processamento" },
  { value: "3", label: "3 - Processado com sucesso" },
  { value: "4", label: "4 - Processado com erro" },
  { value: "5", label: "5 - Erro" }
];

const GRUPOS_EVENTO = [
  { value: "1", label: "1 - Tabela" },
  { value: "2", label: "2 - Não periódico" },
  { value: "3", label: "3 - Periódico" }
];

const tabSx = {
  minWidth: { xs: 84, sm: 120 },
  paddingX: { xs: 1, sm: 2 }
};

function FerramentasPage() {
  const [params] = useSearchParams();
  const [tab, setTab] = useState(() =>
    params.has("recuperacao") || params.get("aba") === "recuperacao" ? 2 : 0
  );
  useEffect(() => {
    if (params.has("recuperacao")) setTab(2);
  }, [params]);

  return (
    <Page maxWidth="lg">
      <PageHeader
        primary="Ferramentas"
        secondary="Consultas e ações operacionais do eSocial-JT"
      />
      <Paper sx={{ maxWidth: "100%", overflow: "hidden" }}>
        <Tabs
          value={tab}
          onChange={(event, value) => setTab(value)}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab
            label="Automação"
            icon={<Icon>schedule</Icon>}
            iconPosition="start"
            sx={tabSx}
          />
          <Tab
            label="Consultas e retornos"
            icon={<Icon>search</Icon>}
            iconPosition="start"
            sx={tabSx}
          />
          <Tab
            label="Recuperação e downloads"
            icon={<Icon>cloud_download</Icon>}
            iconPosition="start"
            sx={tabSx}
          />
          <Tab
            label="Manutenção"
            icon={<Icon>build</Icon>}
            iconPosition="start"
            sx={tabSx}
          />
        </Tabs>
      </Paper>
      <Box marginTop={2}>
        {tab === 0 && <AutomacaoPanel />}
        {tab === 1 && <ConsultasPanel />}
        {tab === 2 && <DownloadsPanel />}
        {tab === 3 && <AcoesPanel />}
      </Box>
    </Page>
  );
}

function AutomacaoPanel() {
  const { data, isLoading } = useAutomacaoStatus();
  const configurarAutomacao = useConfigurarAutomacao();
  const { showSuccess, showError } = useFeedback();
  const [habilitado, setHabilitado] = useState(false);
  const [periodo, setPeriodo] = useState("");

  useEffect(() => {
    if (data) {
      setHabilitado(Boolean(data.habilitado));
      setPeriodo(data.periodoMilis || "");
    }
  }, [data]);

  function handleSubmit(event) {
    event.preventDefault();
    configurarAutomacao.mutate(
      {
        habilitado,
        periodo: periodo ? Number(periodo) : undefined
      },
      {
        onSuccess: () => showSuccess("Configuração de automação atualizada."),
        onError: showError
      }
    );
  }

  return (
    <Section
      title="Processamento automático"
      description="Consulta e altera a execução automática de envio e atualização."
    >
      <DataPanel loading={isLoading}>
        <Stack spacing={2} component="form" onSubmit={handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <Typography variant="body2" color="text.secondary">
                Executor
              </Typography>
              <Typography>{data?.descricao || "Não informado"}</Typography>
            </Grid>
            <Grid item xs={12} md={3}>
              <StatusChip enabled={data?.habilitado} />
            </Grid>
            <Grid item xs={12} md={5}>
              <Typography variant="body2" color="text.secondary">
                Período atual
              </Typography>
              <Typography>{data?.periodoMilis || "-"} ms</Typography>
            </Grid>
          </Grid>
          <Divider />
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <FormControlLabel
                control={
                  <Switch
                    checked={habilitado}
                    onChange={(event) => setHabilitado(event.target.checked)}
                  />
                }
                label="Automação habilitada"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                size="small"
                type="number"
                label="Período (ms)"
                value={periodo}
                onChange={(event) => setPeriodo(event.target.value)}
                inputProps={{ min: 1000 }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Button
                fullWidth
                type="submit"
                variant="contained"
                disabled={configurarAutomacao.isLoading}
              >
                Aplicar
              </Button>
            </Grid>
          </Grid>
        </Stack>
      </DataPanel>
    </Section>
  );
}

function ConsultasPanel() {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <RetConsulta />
      </Grid>
      <Grid item xs={12} md={6}>
        <LoteConsulta />
      </Grid>
      <Grid item xs={12}>
        <TotalizadorConsulta />
      </Grid>
    </Grid>
  );
}

function RetConsulta() {
  const consultarRet = useConsultarRet();
  const { showError } = useFeedback();
  const [tipo, setTipo] = useState("empregado");
  const [cpf, setCpf] = useState("");

  function handleSubmit(event) {
    event.preventDefault();
    consultarRet.mutate(
      { tipo, cpf: onlyDigits(cpf) },
      {
        onError: showError
      }
    );
  }

  return (
    <Section
      title="RET por CPF"
      description="Obtém vínculos enviados para empregado, trabalhador sem vínculo ou beneficiário."
    >
      <Stack spacing={2} component="form" onSubmit={handleSubmit}>
        <TextField
          select
          fullWidth
          size="small"
          label="Tipo de consulta"
          value={tipo}
          onChange={(event) => setTipo(event.target.value)}
        >
          {RET_TYPES.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          required
          fullWidth
          size="small"
          label="CPF"
          value={cpf}
          onChange={(event) => setCpf(event.target.value)}
          inputProps={{ maxLength: 14 }}
        />
        <Button
          type="submit"
          variant="contained"
          disabled={consultarRet.isLoading || onlyDigits(cpf).length !== 11}
        >
          Consultar
        </Button>
        <ResultPanel result={consultarRet.data} />
      </Stack>
    </Section>
  );
}

function LoteConsulta() {
  const consultarLote = useConsultarLote();
  const { showError } = useFeedback();
  const [protocolo, setProtocolo] = useState("");

  function handleSubmit(event) {
    event.preventDefault();
    consultarLote.mutate(protocolo, {
      onError: showError
    });
  }

  return (
    <Section
      title="Consulta de lote"
      description="Consulta o XML de processamento diretamente no eSocial-Gov."
    >
      <Stack spacing={2} component="form" onSubmit={handleSubmit}>
        <TextField
          required
          fullWidth
          size="small"
          label="Protocolo"
          value={protocolo}
          onChange={(event) => setProtocolo(event.target.value)}
        />
        <Button
          type="submit"
          variant="contained"
          disabled={consultarLote.isLoading}
        >
          Consultar
        </Button>
        <ResultPanel result={consultarLote.data} type="xml" />
      </Stack>
    </Section>
  );
}

function TotalizadorConsulta() {
  return (
    <Section
      title="Totalizadores locais"
      description="Consulte os retornos por competência e CPF."
    >
      <TotalizadoresConsulta />
    </Section>
  );
}

function DownloadsPanel() {
  return (
    <Stack spacing={2}>
      <RecuperacaoAssistida />
      <Accordion>
        <AccordionSummary expandIcon={<Icon>expand_more</Icon>}>
          <Typography>Consultas e downloads avançados</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Alert severity="info" sx={{ mb: 2 }}>
            Estas consultas retornam o XML original. Para importar e acompanhar
            totalizadores, use a recuperação acima.
          </Alert>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <DownloadPorId />
            </Grid>
            <Grid item xs={12} md={6}>
              <DownloadPorRecibo />
            </Grid>
            <Grid item xs={12}>
              <IdentificadoresTrabalhador />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
}

function DownloadPorId() {
  const solicitarDownload = useSolicitarDownloadPorId();
  const { showError } = useFeedback();
  const [base, setBase] = useEmpregadorForm();
  const [ids, setIds] = useState("");

  function handleSubmit(event) {
    event.preventDefault();
    solicitarDownload.mutate(
      {
        ...base,
        id: splitValues(ids)
      },
      {
        onError: showError
      }
    );
  }

  return (
    <Section
      title="Download por ID"
      description="Solicita ao eSocial-Gov o download de eventos por identificador."
    >
      <Stack spacing={2} component="form" onSubmit={handleSubmit}>
        <EmpregadorFields values={base} onChange={setBase} />
        <TextField
          required
          fullWidth
          multiline
          minRows={3}
          size="small"
          label="IDs"
          value={ids}
          onChange={(event) => setIds(event.target.value)}
          helperText="Informe um ID por linha ou separados por vírgula."
        />
        <Button
          type="submit"
          variant="contained"
          disabled={solicitarDownload.isLoading || !splitValues(ids).length}
        >
          Solicitar
        </Button>
        <ResultPanel result={solicitarDownload.data} type="xml" />
      </Stack>
    </Section>
  );
}

function DownloadPorRecibo() {
  const solicitarDownload = useSolicitarDownloadPorNrRecibo();
  const { showError } = useFeedback();
  const [base, setBase] = useEmpregadorForm();
  const [recibos, setRecibos] = useState("");

  function handleSubmit(event) {
    event.preventDefault();
    solicitarDownload.mutate(
      {
        ...base,
        nrRec: splitValues(recibos)
      },
      {
        onError: showError
      }
    );
  }

  return (
    <Section
      title="Download por recibo"
      description="Solicita ao eSocial-Gov o download de eventos por número de recibo."
    >
      <Stack spacing={2} component="form" onSubmit={handleSubmit}>
        <EmpregadorFields values={base} onChange={setBase} />
        <TextField
          required
          fullWidth
          multiline
          minRows={3}
          size="small"
          label="Recibos dos eventos para download"
          value={recibos}
          onChange={(event) => setRecibos(event.target.value)}
          helperText="Informe um recibo por linha ou separados por vírgula."
        />
        <Button
          type="submit"
          variant="contained"
          disabled={solicitarDownload.isLoading || !splitValues(recibos).length}
        >
          Solicitar
        </Button>
        <ResultPanel result={solicitarDownload.data} type="xml" />
      </Stack>
    </Section>
  );
}

function IdentificadoresTrabalhador() {
  const consultar = useConsultarIdentificadoresTrabalhador();
  const { showError } = useFeedback();
  const [base, setBase] = useEmpregadorForm();
  const [cpfTrab, setCpfTrab] = useState("");
  const [dtIni, setDtIni] = useState("");
  const [dtFim, setDtFim] = useState("");

  function handleSubmit(event) {
    event.preventDefault();
    consultar.mutate(
      {
        ...base,
        cpfTrab: onlyDigits(cpfTrab),
        dtIni: toDateTimeWithSeconds(dtIni),
        dtFim: toDateTimeWithSeconds(dtFim)
      },
      {
        onError: showError
      }
    );
  }

  return (
    <Section
      title="Identificadores do trabalhador"
      description="Consulta identificadores de eventos por CPF e período."
    >
      <Stack spacing={2} component="form" onSubmit={handleSubmit}>
        <EmpregadorFields values={base} onChange={setBase} />
        <TextField
          required
          fullWidth
          size="small"
          label="CPF do trabalhador"
          value={cpfTrab}
          onChange={(event) => setCpfTrab(event.target.value)}
          inputProps={{ maxLength: 14 }}
        />
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              required
              fullWidth
              size="small"
              type="datetime-local"
              label="Data inicial"
              value={dtIni}
              onChange={(event) => setDtIni(event.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              required
              fullWidth
              size="small"
              type="datetime-local"
              label="Data final"
              value={dtFim}
              onChange={(event) => setDtFim(event.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
        <Button
          type="submit"
          variant="contained"
          disabled={consultar.isLoading || onlyDigits(cpfTrab).length !== 11}
        >
          Consultar
        </Button>
        <ResultPanel result={consultar.data} type="xml" />
      </Stack>
    </Section>
  );
}

function AcoesPanel() {
  return (
    <Stack spacing={2}>
      <Alert severity="warning">
        As ações abaixo podem alterar estados locais ou enviar solicitações ao
        eSocial-Gov. Use apenas em operação assistida.
      </Alert>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <AtualizarProcessamento />
        </Grid>
        <Grid item xs={12} md={6}>
          <EnviarEventos />
        </Grid>
        <Grid item xs={12} md={6}>
          <ExclusaoEmLista />
        </Grid>
        <Grid item xs={12} md={6}>
          <ForcarEstado />
        </Grid>
        <Grid item xs={12}>
          <AbortarProcessamento />
        </Grid>
      </Grid>
    </Stack>
  );
}

function AtualizarProcessamento() {
  const atualizar = useAtualizarProcessamentoLotes();
  const { showSuccess, showError } = useFeedback();
  const [protocolo, setProtocolo] = useState("");

  function handleSubmit(event) {
    event.preventDefault();
    atualizar.mutate(protocolo.trim(), {
      onSuccess: () => showSuccess("Processamento atualizado."),
      onError: showError
    });
  }

  return (
    <Section
      title="Atualizar processamento"
      description="Busca no eSocial-Gov o resultado de lotes pendentes ou de um protocolo específico."
    >
      <Stack spacing={2} component="form" onSubmit={handleSubmit}>
        <TextField
          fullWidth
          size="small"
          label="Protocolo"
          value={protocolo}
          onChange={(event) => setProtocolo(event.target.value)}
          helperText="Deixe em branco para atualizar todos os lotes em processamento."
        />
        <Button
          type="submit"
          variant="contained"
          disabled={atualizar.isLoading}
        >
          Atualizar
        </Button>
        <ResultPanel result={atualizar.data} />
      </Stack>
    </Section>
  );
}

function EnviarEventos() {
  const enviarEventos = useEnviarEventos();
  const { showSuccess, showError } = useFeedback();
  const [filtros, setFiltros] = useEventoFiltros();

  function handleSubmit(event) {
    event.preventDefault();
    enviarEventos.mutate(normalizeEventoFiltros(filtros), {
      onSuccess: () => showSuccess("Eventos enviados para processamento."),
      onError: showError
    });
  }

  return (
    <Section
      title="Enviar ou reenviar eventos"
      description="Dispara envio manual usando filtros de evento."
    >
      <Stack spacing={2} component="form" onSubmit={handleSubmit}>
        <EventoFiltroFields values={filtros} onChange={setFiltros} />
        <Button
          type="submit"
          variant="contained"
          disabled={enviarEventos.isLoading || !hasAnyFilter(filtros)}
        >
          Enviar
        </Button>
        <ResultPanel result={enviarEventos.data} />
      </Stack>
    </Section>
  );
}

function ExclusaoEmLista() {
  const enviarExclusao = useEnviarExclusaoLista();
  const dialog = useDialog();
  const { showSuccess, showError } = useFeedback();
  const [ids, setIds] = useState("");

  async function handleSubmit(event) {
    event.preventDefault();
    const idsLista = splitValues(ids).map(Number);
    await dialog.confirm({
      title: "Deseja enviar S-3000 para as ocorrências informadas?",
      ok: { text: "CONFIRMAR", color: "primary" },
      cancel: { text: "CANCELAR", color: "primary" }
    });
    enviarExclusao.mutate(idsLista, {
      onSuccess: () => showSuccess("Eventos de exclusão enviados."),
      onError: showError
    });
  }

  return (
    <Section
      title="Exclusão em lista"
      description="Envia S-3000 para uma lista de ocorrências."
    >
      <Stack spacing={2} component="form" onSubmit={handleSubmit}>
        <TextField
          required
          fullWidth
          multiline
          minRows={3}
          size="small"
          label="IDs das ocorrências"
          value={ids}
          onChange={(event) => setIds(event.target.value)}
          helperText="Informe um ID por linha ou separados por vírgula."
        />
        <Button
          type="submit"
          variant="contained"
          color="error"
          disabled={enviarExclusao.isLoading || !splitValues(ids).length}
        >
          Enviar exclusões
        </Button>
      </Stack>
    </Section>
  );
}

function ForcarEstado() {
  const forcarEstado = useForcarEstadoEventos();
  const dialog = useDialog();
  const { showSuccess, showError } = useFeedback();
  const [filtros, setFiltros] = useEventoFiltros({ estado: "" });
  const [estadoDestino, setEstadoDestino] = useState("1");

  async function handleSubmit(event) {
    event.preventDefault();
    await dialog.confirm({
      title: "Deseja forçar o estado dos eventos filtrados?",
      ok: { text: "FORÇAR", color: "primary" },
      cancel: { text: "CANCELAR", color: "primary" }
    });
    forcarEstado.mutate(
      {
        filtros: normalizeEventoFiltros(filtros),
        estadoDestino: Number(estadoDestino)
      },
      {
        onSuccess: () => showSuccess("Estado dos eventos atualizado."),
        onError: showError
      }
    );
  }

  return (
    <Section
      title="Forçar estado"
      description="Altera manualmente o estado local dos eventos filtrados."
    >
      <Stack spacing={2} component="form" onSubmit={handleSubmit}>
        <Alert severity="error">
          Esta ação pode deixar o sistema local inconsistente com o eSocial-Gov.
        </Alert>
        <EventoFiltroFields
          values={filtros}
          onChange={setFiltros}
          estadoRequired
        />
        <TextField
          select
          required
          fullWidth
          size="small"
          label="Estado destino"
          value={estadoDestino}
          onChange={(event) => setEstadoDestino(event.target.value)}
        >
          {ESTADOS_EVENTO.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <Button
          type="submit"
          variant="contained"
          color="error"
          disabled={
            forcarEstado.isLoading ||
            !hasAnyFilter(filtros) ||
            !splitValues(filtros.estado).length
          }
        >
          Forçar estado
        </Button>
        <ResultPanel result={forcarEstado.data} />
      </Stack>
    </Section>
  );
}

function AbortarProcessamento() {
  const abortar = useAbortarProcessamentoEventos();
  const dialog = useDialog();
  const { showSuccess, showError } = useFeedback();

  async function handleClick() {
    await dialog.confirm({
      title: "Deseja marcar todos os eventos em processamento como erro?",
      ok: { text: "ABORTAR", color: "primary" },
      cancel: { text: "CANCELAR", color: "primary" }
    });
    abortar.mutate(undefined, {
      onSuccess: () => showSuccess("Processamento abortado."),
      onError: showError
    });
  }

  return (
    <Section
      title="Abortar processamento"
      description="Marca todos os lotes e eventos em processamento como erro."
    >
      <Stack spacing={2}>
        <Alert severity="error">
          Use somente quando houver processamento travado e a situação no
          eSocial-Gov já tiver sido conferida.
        </Alert>
        <Button
          variant="contained"
          color="error"
          disabled={abortar.isLoading}
          onClick={handleClick}
        >
          Abortar processamento
        </Button>
        <ResultPanel result={abortar.data} />
      </Stack>
    </Section>
  );
}

function EmpregadorFields({ values, onChange }) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <TextField
          select
          fullWidth
          size="small"
          label="Tipo inscrição"
          value={values.tpInsc}
          onChange={(event) =>
            onChange({ ...values, tpInsc: Number(event.target.value) })
          }
        >
          <MenuItem value={1}>1 - CNPJ</MenuItem>
          <MenuItem value={2}>2 - CPF</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12} md={8}>
        <TextField
          required
          fullWidth
          size="small"
          label="Inscrição"
          value={values.nrInsc}
          onChange={(event) =>
            onChange({ ...values, nrInsc: onlyDigits(event.target.value) })
          }
          helperText="Somente números, entre 8 e 15 dígitos."
        />
      </Grid>
    </Grid>
  );
}

function EventoFiltroFields({ values, onChange, estadoRequired = false }) {
  return (
    <Stack spacing={2}>
      <TextField
        fullWidth
        size="small"
        label="IDs de eventos"
        value={values.id}
        onChange={(event) => onChange({ ...values, id: event.target.value })}
        helperText="IDs de evento, separados por vírgula ou linha."
      />
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            size="small"
            label="Tipos"
            value={values.tipo}
            onChange={(event) =>
              onChange({ ...values, tipo: event.target.value })
            }
            helperText="Ex.: 1200, 1210"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            select
            fullWidth
            required={estadoRequired}
            size="small"
            label="Estado atual"
            value={values.estado}
            onChange={(event) =>
              onChange({ ...values, estado: event.target.value })
            }
          >
            <MenuItem value="">
              <em>Não filtrar</em>
            </MenuItem>
            {ESTADOS_EVENTO.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            select
            fullWidth
            size="small"
            label="Grupo"
            value={values.grupo}
            onChange={(event) =>
              onChange({ ...values, grupo: event.target.value })
            }
          >
            <MenuItem value="">
              <em>Não filtrar</em>
            </MenuItem>
            {GRUPOS_EVENTO.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
    </Stack>
  );
}

function Section({ title, description, children }) {
  return (
    <Box component={Paper} padding={2} sx={{ maxWidth: "100%" }}>
      <Stack spacing={2}>
        <Box>
          <Typography variant="h6">{title}</Typography>
          {description && (
            <Typography color="text.secondary" variant="body2">
              {description}
            </Typography>
          )}
        </Box>
        {children}
      </Stack>
    </Box>
  );
}

function ResultPanel(props) {
  return <ResultadoOperacao {...props} />;
}

function StatusChip({ enabled }) {
  return (
    <Chip
      label={enabled ? "Habilitada" : "Desabilitada"}
      color={enabled ? "success" : "default"}
      variant="outlined"
    />
  );
}

function useEmpregadorForm() {
  return useState({ tpInsc: 1, nrInsc: "" });
}

function useEventoFiltros(initial = {}) {
  return useState({
    id: "",
    tipo: "",
    estado: "",
    grupo: "",
    ...initial
  });
}

function normalizeEventoFiltros(filtros) {
  return {
    id: splitValues(filtros.id),
    tipo: splitValues(filtros.tipo).map(Number),
    estado: splitValues(filtros.estado).map(Number),
    grupo: splitValues(filtros.grupo).map(Number)
  };
}

function hasAnyFilter(filtros) {
  const normalized = normalizeEventoFiltros(filtros);
  return Object.values(normalized).some((value) => value.length);
}

function splitValues(value) {
  return String(value || "")
    .split(/[\n,;]/)
    .map((item) => item.trim())
    .filter(Boolean);
}

function onlyDigits(value) {
  return String(value || "").replace(/\D/g, "");
}

function toDateTimeWithSeconds(value) {
  return value && value.length === 16 ? `${value}:00` : value;
}

export default FerramentasPage;
